import { useState } from "react";
import { Flex, Box } from "@chakra-ui/react";
import NavigationBar from "src/components/NavigationBar";
import { ReactComponent as DeleteIcon } from "src/icons/delete-outlined.svg";
import Profile from "./Components/Profile";
import Appearance from "./Components/Appearance";
import AvatarPreview from "../AvatarPreview";
import CategorySelect from "../CategorySelect";

const Categories = {
  Bio: 0,
  Appearance: 1
};
const Previews = {
  Sleeping: 0,
  Awake: 1
};

export default function AvatarEditorView({
  avatar,
  croppedAvatar,
  onSubmit,
  onAvatarSelection,
  t,
  onClose,
  onBack,
  onDelete,
  onInputChange,
  handleDateChange,
  handleAvatarStyleUpdate,
  changeAvatarMode
}) {
  const { name, objectId } = avatar;
  const [category, setCategory] = useState(Categories.Bio);
  const [avatarPreview, setAvatarPreview] = useState(Previews.Sleeping);
  const isSleeping = avatarPreview === Previews.Sleeping;

  const Components = {
    [Categories.Bio]: (
      <Profile
        onAvatarSelection={onAvatarSelection}
        handleDateChange={handleDateChange}
        onInputChange={onInputChange}
        croppedAvatar={croppedAvatar}
        avatar={avatar}
        t={t}
      />
    ),
    [Categories.Appearance]: (
      <Appearance
        avatar={avatar}
        handleAvatarStyleUpdate={handleAvatarStyleUpdate}
      />
    )
  };

  return (
    <>
      <NavigationBar
        headingKey="avatar.editAvatar"
        actionButton={{
          labelKey: "buttons.save",
          form: "avatar.editor",
          type: "submit",
          disabled: name === ""
        }}
        actionIcon={
          objectId
            ? {
                onClick: onDelete,
                icon: DeleteIcon
              }
            : null
        }
        onBack={onBack}
        onClose={onClose}
      />
      <Flex
        width="100%"
        px="12px"
        as="form"
        id="avatar.editor"
        onSubmit={onSubmit}
        height="calc(100% - 61px)"
      >
        <AvatarPreview
          mt="16px"
          mr="24px"
          avatar={avatar}
          Previews={Previews}
          handlePreviewChange={(newPreview) => setAvatarPreview(newPreview)}
          preview={avatarPreview}
          isSleeping={isSleeping}
          changeAvatarMode={changeAvatarMode}
          onAvatarSelection={onAvatarSelection}
          croppedAvatar={croppedAvatar}
          t={t}
        />
        <Box mt="16px" width="100%">
          <CategorySelect
            t={t}
            selectedCategory={category}
            categories={Object.entries(Categories)}
            onSelect={(category) => setCategory(category)}
          />
          {Components[category]}
        </Box>
      </Flex>
    </>
  );
}
